import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  styled,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';

// Arka plan resmini stilize edilmiş bir Box bileşeni ile ekliyoruz
const BackgroundBox = styled(Box)({
  backgroundImage: `url('https://pdks.bytebridge.com.tr/static/IOT-Icons.jpeg')`, // Backend'den serving
  backgroundColor: '#f0f2f5', // Fallback color
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent overlay
    zIndex: 1,
  },
  '& > *': {
    position: 'relative',
    zIndex: 2,
  }
});

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Check if user is already logged in
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Basic validation
      if (!email || !password) {
        setError('Lütfen e-posta ve şifre giriniz');
        setLoading(false);
        return;
      }

      console.log('Login form submitting...');
      const result = await login(email, password);
      
      if (result && result.success) {
        console.log('Login successful, redirecting...');
        // If login is successful, redirect to dashboard or previous location
        const from = location.state?.from?.pathname || '/';
        navigate(from, { replace: true });
      } else {
        console.log('Login failed:', result);
        setError(result?.message || 'Geçersiz e-posta veya şifre');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Giriş sırasında bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <BackgroundBox>
      <Container component="main" maxWidth="xs">
        <Paper elevation={3} sx={{ p: 4, width: '100%', backdropFilter: 'blur(5px)', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
            <Tooltip title="Giriş yapmak için bilgilerinizi giriniz.">
              <InfoOutlinedIcon color="primary" style={{ marginRight: 8, cursor: 'pointer' }} />
            </Tooltip>
            <Typography component="h1" variant="h5" align="center" gutterBottom style={{ margin: 0 }}>
              PDKS Giriş
            </Typography>
          </div>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="E-posta Adresi"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!error}
              disabled={loading}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Şifre"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!error}
              helperText={error}
              disabled={loading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </Button>
          </Box>
        </Paper>
      </Container>
    </BackgroundBox>
  );
}

export default Login;